import { v4 as uuid } from "uuid";
import { avatarDB } from "../../utils/avatarDB";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */
const {
	chaupalAvatar,
	dedsecAvatar,
	jeetsdevAvatar,
	adiiAvatar,
	harviAvatar,
	ninjaAvatar,
	capAvatar,
	tonyAvatar,
} = avatarDB;

export const users = [
	{
		_id: uuid(),
		fullName: "Chaupal",
		username: "chaupal",
		password: "chaupal@123",
		bio: "Lets chat and meet",
		website: "https://chaupal-jeetsdev.netlify.app/",
		avatar: chaupalAvatar,
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [{ _id: uuid(), username: "jeetsdev" }],
	},
	{
		_id: uuid(),
		fullName: "Jeet",
		username: "jeetsdev",
		bio: "Learning and growing...",
		website: "https://jeetsdev.netlify.app/",
		avatar: jeetsdevAvatar,
		password: "jeetsdev@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [
			{ _id: uuid(), username: "jeetsdev" },
			{ _id: uuid(), username: "adii" },
			{ _id: uuid(), username: "tony" },
			{ _id: uuid(), username: "ninja" },
			{ _id: uuid(), username: "dedsec" },
			{ _id: uuid(), username: "cap" },
		],
		following: [
			{ _id: uuid(), username: "jeetsdev" },
			{ _id: uuid(), username: "tony" },
			{ _id: uuid(), username: "ninja" },
		],
	},
	{
		_id: uuid(),
		fullName: "Boolean",
		username: "dedsec",
		bio: "Unavilable for lifetime.",
		website: "https://dedsec.netlify.app/",
		avatar: dedsecAvatar,
		password: "notme@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
	{
		_id: uuid(),
		fullName: "Harvi",
		username: "harvi",
		bio: "Nothing here and there...",
		website: "https://harvi.netlify.app/",
		avatar: harviAvatar,
		password: "harvi@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
	{
		_id: uuid(),
		fullName: "Avinash",
		username: "ninja",
		bio: "Let me show, how to slay...",
		website: "https://ninja.netlify.app/",
		avatar: ninjaAvatar,
		password: "ninja@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
	{
		_id: uuid(),
		fullName: "Meow",
		username: "adii",
		bio: "Someone, You can't avoid...",
		website: "https://adii.netlify.app/",
		avatar: adiiAvatar,
		password: "adii@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
	{
		_id: uuid(),
		fullName: "Captain",
		username: "cap",
		bio: "I can do this all day.",
		website: "https://cap.netlify.app/",
		avatar: capAvatar,
		password: "cap@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
	{
		_id: uuid(),
		fullName: "Tony",
		username: "tony",
		bio: "I am Iron Man...",
		website: "https://tony.netlify.app/",
		avatar: tonyAvatar,
		password: "tony@123",
		createdAt: formatDate(),
		updatedAt: formatDate(),
		followers: [],
		following: [],
	},
];
